<template>
  <div class="stats-banner">
    <v-card
      class="stat-card"
      elevation="1"
      rounded="lg"
      :loading="loading"
    >
      <div class="stat-label">
        Total Chargers
      </div>
      <div class="stat-body">
        <div class="stat-value">
          {{ items?.total_chargers || 0 }}
        </div>
      </div>
    </v-card>
    <!-- ── Card 1: Avg. Completeness % ── -->
    <v-card
      class="stat-card"
      elevation="1"
      rounded="lg"
      :loading="loading"
    >
      <div class="stat-label">
        AVG. COMPLETENESS %
      </div>
      <div class="stat-body">
        <div class="stat-value green--text">
          {{ tiles?.avg_completeness_percent || 0 }}%
        </div>
        <div class="ring-wrap">
          <svg
            viewBox="0 0 44 44"
            class="ring-svg"
          >
            <circle
              cx="22"
              cy="22"
              r="18"
              class="ring-track"
            />
            <circle
              cx="22"
              cy="22"
              r="18"
              class="ring-fill"
              :stroke-dasharray="`${1 * 1.131} 113.1`"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>
    </v-card>

    <!-- ── Card 2: Active Data Gaps ── -->
    <v-card
      class="stat-card"
      elevation="1"
      rounded="lg"
    >
      <div class="stat-label">
        ACTIVE DATA GAPS
      </div>
      <div class="stat-body">
        <div class="stat-value">
          {{ items?.active_data_gaps?.count || 0 }}
        </div>
        <div
          class="delta-badge"
          :class="
            items?.active_data_gaps?.delta_from_1h ? 'delta-up' : 'delta-down'
          "
        >
          <v-icon size="10">
            {{
              items?.active_data_gaps?.delta_from_1h
                ? "mdi-arrow-up"
                : "mdi-arrow-down"
            }}
          </v-icon>
          {{ items?.active_data_gaps?.delta_from_1h }} from 1hr
        </div>
      </div>
    </v-card>

    <!-- ── Card 3: Syncing Chargers ── -->
    <v-card
      class="stat-card"
      elevation="1"
      rounded="lg"
    >
      <div class="stat-label">
        SYNCING CHARGERS
      </div>
      <div class="stat-body">
        <div class="stat-value">
          {{ items?.syncing_chargers?.count }}
        </div>
        <div class="sync-status">
          <span class="sync-dot" />
          <span class="sync-text">{{ items?.syncing_chargers?.label }}</span>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "DataCompletenessCards",

  props: {
    loading: Boolean,
    items: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
/* ── Layout ── */
.stats-banner {
  display: flex;
  gap: 12px;
}

/* ── Shared Card ── */
.stat-card {
  flex: 1;
  background: #ffffff !important;
  border: 1px solid #e8ecf0 !important;
  padding: 0px 20px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

/* ── Label ── */
.stat-label {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #9aa5b4;
  text-transform: uppercase;
  padding-top: 1.5rem;
}

/* ── Body row ── */
.stat-body {
  display: flex;
  align-items: center;
  gap: 14px;
}

/* ── Value ── */
.stat-value {
  font-size: 32px;
  font-weight: 500;
  color: #1a202c;
  line-height: 1;
}

.stat-value.green--text {
  color: #16a34a !important;
}

/* ── Ring SVG ── */
.ring-wrap {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.ring-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.ring-track {
  fill: none;
  stroke: #e8f5e9;
  stroke-width: 4;
}

.ring-fill {
  fill: none;
  stroke: #16a34a;
  stroke-width: 4;
  transition: stroke-dasharray 0.8s ease;
}

/* ── Delta badge ── */
.delta-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 3px 8px;
  border-radius: 4px;
}

.delta-up {
  background: #fef2f2;
  color: #dc2626;
}

.delta-up .v-icon {
  color: #dc2626 !important;
}

.delta-down {
  background: #f0fdf4;
  color: #16a34a;
}

.delta-down .v-icon {
  color: #16a34a !important;
}

/* ── Sync status ── */
.sync-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sync-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #f59e0b;
  animation: blink 1.4s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}

.sync-text {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #f59e0b;
  text-transform: uppercase;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .stats-banner {
    flex-direction: column;
  }
}
</style>
